export default __webpack_public_path__ + "static/media/plots2.90947915.png";